import { useFetch } from "~vue/api";
import { openUrl } from "~vue/utils";
import { computed, type MaybeRefOrGetter, ref, toValue } from "vue";

export interface CreateLabInsightChatResponse {
    coaching_session_url: string;
    coaching_session_id: number;
    prompt_call_code: string;
    insight_id: string;
}

type StartLabInsightChatOptions = {
    navigateOnSuccess?: boolean;
};

export function useLabInsightChat(insightId: MaybeRefOrGetter<string>) {
    const chatError = ref<string | null>(null);
    const chatPayload = computed(() => ({ insight_id: toValue(insightId) }));
    const {
        data: chatData,
        isFetching: isStartingChat,
        error: chatFetchError,
        execute: startChat,
    } = useFetch("/api/labs/insights/chat/", { immediate: false }).post(chatPayload).json<CreateLabInsightChatResponse>();

    async function handleStartChat({ navigateOnSuccess = true }: StartLabInsightChatOptions = {}): Promise<CreateLabInsightChatResponse | null> {
        if (isStartingChat.value) {
            return null;
        }

        chatError.value = null;
        await startChat();

        const response = chatData.value;
        if (chatFetchError.value || !response?.coaching_session_url) {
            chatError.value = "Something went wrong. Please try again.";
            return null;
        }

        if (navigateOnSuccess) {
            openUrl(response.coaching_session_url);
        }
        return response;
    }

    return {
        isStartingChat,
        chatError,
        handleStartChat,
    };
}
